import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["type"];
const _hoisted_2 = {
    key: 0,
    class: "btn__icon"
};
import Icon from "./Icon.vue";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Button',
    props: {
        type: { type: String, default: 'button' },
        styling: { type: String, default: '2' },
        color: { type: String, default: 'black' },
        icon: String,
        label: String,
        size: { type: String, default: 'm' },
    },
    setup(__props) {
        const props = __props;
        const classList = computed(() => ({
            'btn--icon': !props.label && props.icon,
            [`btn--${props.size}`]: true,
            [`btn--${props.styling}`]: true,
            [`btn--${props.color}`]: true,
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", {
                type: __props.type,
                class: _normalizeClass(["btn", classList.value])
            }, [
                (__props.icon)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                        _createVNode(Icon, { name: __props.icon }, null, 8 /* PROPS */, ["name"])
                    ]))
                    : _createCommentVNode("v-if", true)
            ], 10 /* CLASS, PROPS */, _hoisted_1));
        };
    }
});
